<template>
  <div class="cube-bottom-nav" :style="getWidth_">
    <div class="cube-bottom-nav-wrap">
      <div class="cube-bottom-nav-top">
        <div>
          <slot name="logo">
            <img  :src="logo" :width="logoWidth" :height="logoHeight" />
          </slot>
        </div>
        <div class="cube-bottom-nav-top-list">
          <slot />
        </div>
        <div class="cube-bottom-nav-top-right">
          <slot name="top-right">
          </slot>
        </div>
      </div>
      <div  v-if="$slots.bottom" class="cube-bottom-nav-bottom border-top">
        <slot name="bottom"></slot>
      </div>
    </div>
    <div v-if="$slots.right" class="cube-bottom-nav-right">
      <slot name="right"></slot>
    </div>
  </div>
</template>
<script>
import '../../../../lib/styles/components/BottomNav.scss'
export default {
  name: 'BottomNav',
  props: {
    logo: {
      type: String,
      default: ''
    },
    logoWidth: {
      type: String,
      default: ''
    },
    logoHeight: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '100%'
    }
  },
  computed: {
    getWidth_() {
      return `width:${this.width}`
    }
  }

}
</script>
